import React from 'react';
import { useMsal } from '@azure/msal-react';

// images
import backLogin from '../../assets/img/login-bk.jpg';
import IDB from '../../assets/img/IDB-Logo.png';
import { loginRequest } from '../../services/auth';

const Login: React.FC = () => {
    const { instance } = useMsal();
    const fuente = {
        fontSize: 15,
        margin: 0,
    };

    const handleLogin = () => {
        instance.loginRedirect(loginRequest);
    };

    return (
        <main id='login'>
            <div className='row'>
                <div className='col-12 col-md-6 pad-0 d-none d-md-block'>
                    <div className='img-back'>
                        <img src={backLogin} alt='' />
                        <div className='filter'></div>
                    </div>
                </div>
                <div className='col-12 col-md-6 pad-0 log  p-relative'>
                    <div className='form'>
                        <h2 className='mb-4'>Dashboard de Obras</h2>
                        <p className='px-5' style={fuente}>
                            Es una herramienta de visualización que permite presentar los resultados
                            de la información de los contratos de infraestructura de transporte.
                            Permite realizar análisis de tendencias, comparativos y proyecciones de
                            los intervalos de confianza en diversos escenarios para los países de la
                            región. Analiza variables como monto total, plazo, estado de ejecución,
                            tipo de contrato, monto desembolsado, entre otras.
                        </p>
                        <br />

                        <button onClick={() => handleLogin()} className='signin cursor-pointer'>
                            Login
                        </button>
                    </div>
                    <footer className='d-flex'>
                        <nav>
                            <a href='/'>Term of use. Privacy policy</a>
                        </nav>
                        <div className='logo'>
                            <img src={IDB} alt='IDB Logo' />
                        </div>
                    </footer>
                </div>
            </div>
        </main>
    );
};

export default Login;
